import styled from "styled-components";

const LogoBlock = styled.div``;

LogoBlock.Preland = styled.div`
  display: flex;
  align-items: center;
`;
LogoBlock.Preland.Left = styled.div`
  margin-right: 11px;
`;

LogoBlock.Preland.Right = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export { LogoBlock };
